import LogRocket from 'logrocket'
import Bugsnag from '@bugsnag/js'

export const init = async () => {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_CODE, {
    mergeIframes: true,
    childDomains: ['*'],
  })
  LogRocket.getSessionURL((sessionURL) => {
    Bugsnag.addMetadata('LogRocket', { sessionURL })
  })
}

export const identify = (userId, userData) => {
  LogRocket.identify(userId, {
    name: userData.name,
    email: userData.email,
    accountId: userData.accountId,
    accountName: userData.accountName,
    isAdmin: userData.isAdmin,
    isInternal: userData.isInternal, // this should always be true, but passing through just in case
  })
}
export const track = (label) => {
  LogRocket.track(label)
}
